export default __webpack_public_path__ + "5e1ff1ae24cb6366617e241596cf6906.svg";